export const COOKIE_PREFERENCES_STATS = 'statsCookie';
export const COOKIE_PREFERENCES_PERSO = 'persoCookie';
export const COOKIE_PREFERENCES_MEDIA = 'mediaCookie';
export const COOKIE_PREFERENCES_LAYER = 'cookiePreferences';
export const COOKIE_WARNING_LOCALSTORAGE_KEY = 'cookieBanner';
export const COOKIES_ARRAY = [
  COOKIE_PREFERENCES_STATS,
  COOKIE_PREFERENCES_PERSO,
  COOKIE_PREFERENCES_MEDIA,
];
